import { createRouter, createWebHistory } from "vue-router";
import roles from "../utils/roles";
import store from "../store/index.js";

import { homeRouters } from "./routers/home.js";
import { infoRouters } from "./routers/info.js";
import { userRouters } from "./routers/users.js";
import { schemaRouters } from "./routers/schema.js";
import { errorRouters } from "./routers/error.js";
import { contactsRouters } from "./routers/contacts.js"
import { adminRouters } from "./routers/admin.js"
import { tasksRouters } from "./routers/tasks.js"
import { kanbanRouters } from "./routers/kanban.js"
import { calendarRouters } from "./routers/calendar.js"
import { mermaidRouters } from "./routers/mermaid.js"
import { filesRouters } from "./routers/files.js" 
import { sliderRouters } from "./routers/slider.js" 
import { unitsRouters } from "./routers/units.js" 
import { optionsRouters } from "./routers/options.js" 
import { sinifRouters } from "./routers/sinif.js" 
import { dersRouters } from "./routers/ders.js" 
import { schoolsRouters } from "./routers/schools.js" 
import { studentsRouters } from "./routers/students.js" 
import { subjectsRouters } from "./routers/subjects.js" 
import { simulationRouters } from "./routers/simulation.js" 
import { examRouters } from "./routers/exam.js" 
//import


const router = createRouter({ 
    routes: [
        ...homeRouters,
        ...examRouters,
        ...simulationRouters,
        ...subjectsRouters,
        ...studentsRouters,
        ...schoolsRouters,
        ...dersRouters,
        ...sinifRouters,
        ...optionsRouters,
        ...unitsRouters,
        ...sliderRouters,
        ...filesRouters,
        ...contactsRouters,
        ...infoRouters,
        ...userRouters,
        ...schemaRouters,
        ...adminRouters,
        ...tasksRouters,
        ...kanbanRouters,
        ...calendarRouters,
        ...mermaidRouters,
        ...errorRouters,
        {
          path: '/students/create/:schoolId',
          name: 'StudentsCreate',
          component: () => import('../views/students/Create.vue')
        },
        {
          path: '/students/createexcel/:schoolId',
          name: 'StudentsCreateExcel',
          component: () => import('../views/students/CreateExcel.vue')
        },
        {
          path: '/gemini',
          name: 'GeminiDemo',
          component: () => import('../views/GeminiExample.vue')
        }
    ],

    // use url #
    //history: createWebHashHistory() 
    history: createWebHistory()

})

router.beforeEach((to, from, next) => {
  const role = store.getters._getCurrentRole || 1;
  const isAuth = store.getters._getCurrentUser !== null;

  console.log("page", to.name);

  if(isAuth && to.name == "HomePage"){
    //next({ name: "UsersHome" });

    next();
  }else{
    if (!roles[to.name]) {
      next({ name: "Error404" });
    } else {
      if (roles[to.name].includes(role)) {
        next();
      } else {
        next({ name: "ErrorPage" });
      }
    }
  }

  //next({ name: "LoginPage" });
  //next(false) //home page route
});

export default router;
